import { gql } from '@apollo/client';

export const ROSTERPLAYERS = gql`
  query getRosterMembers($rosterId: String!, $role: RosterRoleEnum!, $seasonId: String!) {
    getRosterMembers(rosterId: $rosterId, role: $role, seasonId: $seasonId) {
      personId
      tennisId
      standardGivenName
      standardFamilyName
      class
      avatarUrl
      worldTennisNumbers{
        confidence
        type
        tennisNumber
        isRanked
      }
    }
  }
`;
